import React, { useEffect, useState } from "react";
import {
  getIsTheValueNotMatchedWithRegex,
  convertTenDigitPhoneNumberToNANP,
} from "../utils/commonUtilities";
import "./CgInputField.scss";

const CgInputField = ({
  label,
  deleteField = false,
  type, // email, text, number
  name,
  required,
  validateEmail,
  placeholder,
  defaultValue,
  showCheckbox,
  checkboxLabel,
  checkboxDefaultValue,
  valueChangeCallback,
  resetValue,
  onCheckboxValueChange,
  disabled = false, // disbale input field (boolean value)
  handleButtonClickCallback = () => {},
  btnClassName,
  enableCustomRender = false,
  maxLength,
  minLength,
  renderCustomError, // boolean value
  customErrorMsg, // string
  popupErrorMsg,
  customPhoneNumberDisplay = false,
  customDateDisplay = false,
  onKeyChangeCallback = () => {},
  inputProps,
  shouldRenderInputCheckboxWithBackgroundImageStyle = false,
}) => {
  const [isDataReady, setIsDataReady] = useState(false);
  const [value, setValue] = useState();
  const [isChecked, setIsChecked] = useState(
    checkboxDefaultValue ? checkboxDefaultValue : false
  );
  const [error, setError] = useState("");
  const [isInputPatternFailed, setIsInputPatternFailed] = useState(false);

  useEffect(() => {
    if (resetValue && !defaultValue) {
      setValue("");
    }
    if (resetValue && defaultValue) {
      setValue(defaultValue);
    }
  }, [resetValue]);

  useEffect(() => {
    if (defaultValue && !customPhoneNumberDisplay && !customDateDisplay) {
      setValue(defaultValue);
    }
    if (defaultValue && customPhoneNumberDisplay) {
      let value = defaultValue.replace(/\D/g, "");

      if (value.length > 12) value = value.slice(0, 12);

      if (value.length > 6) {
        value = `${value.slice(0, 3)}-${value.slice(3, 6)}-${value.slice(6)}`;
      } else if (value.length > 3) {
        value = `${value.slice(0, 3)}-${value.slice(3)}`;
      }
      setValue(value);
    }
    if (defaultValue && customDateDisplay) {
      setValue(defaultValue);
    }
    setIsDataReady(true);
  }, []);

  const handleBlur = () => {
    if (required && !value?.trim()) {
      setError(`${label} is required`);
    } else if (validateEmail && type === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(value)) {
        setError("Invalid Email Format");
      } else {
        setError("");
      }
    } else {
      setError("");
    }
    valueChangeCallback?.(name, value);
  };

  const handleChange = (e) => {
    let value = e.target.value;
    onKeyChangeCallback(name, value);
    setValue(value);
    setError("");
    if (inputProps?.pattern) {
      const isTheValueNotMatchedWithRegex = getIsTheValueNotMatchedWithRegex({
        pattern: inputProps.pattern,
        value,
        required,
      });
      if (isTheValueNotMatchedWithRegex) {
        setIsInputPatternFailed(true);
      } else {
        setIsInputPatternFailed(false);
      }
    }
  };

  const handleCustomPhoneChange = (e) => {
    let value = e.target.value.replace(/\D/g, "");
    value = convertTenDigitPhoneNumberToNANP(value);
    setValue(value);
    onKeyChangeCallback(name, value);
    setError("");
  };

  const handleCustomDateChange = (e) => {
    let value = e.target.value.replace(/[^0-9]/g, "");
    if (type === "month") {
      if (value.length <= 2) {
        // eslint-disable-next-line no-self-assign
        value = value;
      } else if (value.length <= 6) {
        value = `${value.slice(0, 2)}/${value.slice(2, 6)}`;
      }
    } else {
      if (value.length <= 2) {
        // eslint-disable-next-line no-self-assign
        value = value;
      } else if (value.length <= 4) {
        value = `${value.slice(0, 2)}/${value.slice(2)}`;
      } else if (value.length <= 8) {
        value = `${value.slice(0, 2)}/${value.slice(2, 4)}/${value.slice(4)}`;
      }
    }

    // if (value.length > 2) {
    //   value = `${value.slice(0, 2)}/${value.slice(2)}`;
    // } else if (value.length > 4) {
    //   value = `${value.slice(0, 2)}/${value.slice(2, 4)}`;
    // }
    setValue(value);
    onKeyChangeCallback(name, value);
    setError("");

    if (inputProps?.pattern) {
      const isTheValueNotMatchedWithRegex = getIsTheValueNotMatchedWithRegex({
        pattern: inputProps.pattern,
        value,
        required,
      });
      if (isTheValueNotMatchedWithRegex) {
        setIsInputPatternFailed(true);
      } else {
        setIsInputPatternFailed(false);
      }
    }
  };

  // render functions
  const RenderCheckbox = () => {
    return (
      <div
        className={`inputCheckboxWrapper ${
          shouldRenderInputCheckboxWithBackgroundImageStyle
            ? "checkbox-background-style"
            : ""
        }`}
      >
        <div className="form-check inputWrapper">
          <input
            className="form-check-input"
            id="flexCheckDefault"
            type="checkbox"
            value={checkboxLabel}
            defaultValue={isChecked}
            checked={isChecked}
            onChange={() => {
              setIsChecked(!isChecked);
              setValue("");
              onCheckboxValueChange(!isChecked);
            }}
          />
          <label
            className="form-check-label"
            htmlFor="flexCheckDefault"
            style={{
              fontSize: "14px",
              marginTop: "unset",
              pointerEvents: "none",
              textTransform: "uppercase",
            }}
          >
            {checkboxLabel}
          </label>
        </div>
      </div>
    );
  };

  const RenderInputButton = () => {
    if (type !== "button" || enableCustomRender) return null;
    return (
      <div className={`inputFieldWrapper ${disabled ? "disable" : ""}`}>
        <input
          className={btnClassName ? btnClassName : "button"}
          id={name}
          name={name}
          type="button"
          value={label}
          onClick={handleButtonClickCallback}
        />
      </div>
    );
  };

  const RenderCustomRender = () => {
    if ((!enableCustomRender && !deleteField) || type === "button") return null;
    return (
      <div className={`inputFieldWrapper ${disabled ? "disable" : ""}`}>
        <label className="form-label">{label}</label>
        <input />
      </div>
    );
  };

  const RenderInputField = () => {
    if (
      type === "button" ||
      enableCustomRender ||
      customPhoneNumberDisplay ||
      customDateDisplay
    )
      return null;
    return (
      <>
        <div className={`inputFieldWrapper`}>
          {<label className="form-label">{label}</label>}
          <input
            disabled={disabled || isChecked}
            id={name}
            name={name}
            type={type}
            maxLength={maxLength}
            minLength={minLength}
            defaultValue={defaultValue}
            value={value}
            onChange={(e) => {
              if (type === "number" && maxLength) {
                const input = e.target.value;
                if (input.length <= maxLength) {
                  handleChange(e);
                }
              } else {
                handleChange(e);
              }
            }}
            onBlur={handleBlur}
            min={type === "date" ? "1900-01-01" : undefined}
            max={type === "date" ? "2100-01-01" : undefined}
            placeholder={placeholder ? placeholder : ""}
            className={`form-control ${
              (error && required) || isInputPatternFailed
                ? "form-control error"
                : ""
            } ${renderCustomError ? "form-control error" : ""} `}
          />
        </div>
        {customErrorMsg && (
          <div className="commonCustomErrorMsg"> {customErrorMsg} </div>
        )}
        {isInputPatternFailed && inputProps?.title ? (
          <div className="commonCustomErrorMsg"> {inputProps.title} </div>
        ) : null}
        {popupErrorMsg && (
          <div className="popoverPasswordHint">
            <div className="arrow"></div>
            <p>
              Password length must be at least eight(8) characters and must
              contain three of the four character types – upper case, lower
              case, numeric and/or special character
            </p>
          </div>
        )}
      </>
    );
  };

  const RenderCustomPhoneInputField = () => {
    if (!customPhoneNumberDisplay) return null;
    return (
      <>
        <div className={`inputFieldWrapper ${disabled ? "disable" : ""}`}>
          {<label className="form-label">{label}</label>}
          <input
            disabled={isChecked}
            id={name}
            name={name}
            type={"text"}
            maxLength={maxLength}
            minLength={minLength}
            defaultValue={defaultValue}
            value={value}
            onChange={(e) => {
              if (type === "number" && maxLength) {
                const input = e.target.value;
                if (input.length <= maxLength) {
                  handleCustomPhoneChange(e);
                }
              }
            }}
            onBlur={handleBlur}
            min={type === "date" ? "1900-01-01" : undefined}
            max={type === "date" ? "2100-01-01" : undefined}
            placeholder={placeholder ? placeholder : ""}
            className={`form-control ${
              error && required ? "form-control error" : ""
            } ${renderCustomError ? "form-control error" : ""} `}
          />
        </div>
        {customErrorMsg && (
          <div className="commonCustomErrorMsg"> {customErrorMsg} </div>
        )}
        {popupErrorMsg && (
          <div className="popoverPasswordHint">
            <div className="arrow"></div>
            <p>
              Password length must be at least eight(8) characters and must
              contain three of the four character types – upper case, lower
              case, numeric and/or special character
            </p>
          </div>
        )}
      </>
    );
  };

  const RenderCustomDateDisplay = () => {
    if (!customDateDisplay) return null;
    return (
      <>
        <div className={`inputFieldWrapper ${disabled ? "disable" : ""}`}>
          {<label className="form-label">{label}</label>}
          <input
            disabled={isChecked}
            id={name}
            name={name}
            type={"text"}
            maxLength={maxLength ?? 10}
            minLength={minLength}
            defaultValue={defaultValue}
            value={value}
            onChange={handleCustomDateChange}
            onBlur={handleBlur}
            min={type === "date" ? "1900-01-01" : undefined}
            max={type === "date" ? "2100-01-01" : undefined}
            placeholder={placeholder ? placeholder : ""}
            className={`form-control ${
              (error && required) || isInputPatternFailed
                ? "form-control error"
                : ""
            } ${renderCustomError ? "form-control error" : ""} `}
          />
        </div>
        {customErrorMsg && (
          <div className="commonCustomErrorMsg"> {customErrorMsg} </div>
        )}
        {popupErrorMsg && (
          <div className="popoverPasswordHint">
            <div className="arrow"></div>
            <p>
              Password length must be at least eight(8) characters and must
              contain three of the four character types – upper case, lower
              case, numeric and/or special character
            </p>
          </div>
        )}
      </>
    );
  };

  return (
    <div>
      {isDataReady && RenderInputField()}
      {isDataReady && RenderCustomPhoneInputField()}
      {isDataReady && RenderCustomDateDisplay()}
      {isDataReady && RenderCustomRender()}
      {isDataReady && RenderInputButton()}
      {isDataReady && showCheckbox && RenderCheckbox()}
    </div>
  );
};

export default CgInputField;
